import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingBeefPrimaryData } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_PRIMARY_DATA } from "consts";

export const useSubmitFootprintingBeefPrimaryData = (farmId: string, year: number, primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_BEEF_PRIMARY_DATA, primaryDataId, isAdmin],
      mutationFn: async () => setFootprintingBeefPrimaryData({ farmId, year, isSubmitted: true }, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [...footprintingBeefPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
